<template>
    <div>
        <el-table
        v-loading="loading"
        :data="tableData"
        :pubstat="goodType"
        :header-cell-style="headClass"
        stripe
        fit
        style="width: 100%; font-size: 12px"
        >
            <!-- <el-table-column
            align="center"
            prop="goodsType"
            label="类型">
            <template slot-scope="scope">
                <span >{{getgoodstypename(scope.row.goodsType)}}</span>
            </template>
            </el-table-column> -->
            <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="goodsName"
            label="标题"
            >
            </el-table-column>
            <el-table-column
            align="center"
            prop="amount"
            label="金额（￥）"
            >
            <template slot-scope="scope">
              <span :class="[scope.row.incomeUserid == scope.row.payUserid ?'dn':'gren'] " v-if="scope.row.incomeUserid == id">{{ '+' + scope.row.amount }}</span>
              <span :class="[scope.row.incomeUserid == scope.row.payUserid ?'dn':'err'] " v-if="scope.row.payUserid == id">{{- scope.row.amount}}</span>
              <span class="gren" v-if="scope.row.incomeUserid == scope.row.payUserid ">{{'+' + scope.row.amount}}</span>
            </template>
            </el-table-column>
            <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="transDate"
            label="时间"
            >
            </el-table-column>
            <el-table-column
            align="center"
            prop="userName"
            label="用户"
            >
            </el-table-column>
           </el-table>
                <!--分页-->
            <Pagination
                v-show="total > 0"
                :total="total"
                :page.sync="listQuery.curPage"
                :limit.sync="listQuery.limit"
                @pageChange="Recepage"
            ></Pagination>
    </div>
</template>
<script>
import {incomeList} from "@/api/coment";
import Pagination from './Pagination'
export default {
  components:{Pagination},
  props: { // 接收父组件传值
    pubstat: {
      type: String,
      default: '0'
    }
  },
  data(){
    return{
      tableData:[],
      loading: false,
      listQuery: {
        curPage: 1,
        limit: 5,
        goodstypes:''
      },
      dataQuery:{
        curPage: 1,
        limit: 5,
        querytype:0
      },
      total:0,
      id:''
    }
  },
  created(){
   this.getIncomeList();
   this.id = this.$store.state.user.userInfo.data.userId;
  },
  computed:{
     goodType(){
       const pubstat = this.pubstat;
       if(pubstat == 0){
         this.listQuery.goodstypes = '';
         this.getIncomeList();
       }else{
         switch(Number(pubstat)){
          case 2:  //收入
            this.dataQuery.querytype = 2 ;
            this.getIncome();
           break;
           case 3: //支出
            this.dataQuery.querytype = 1;
            this.getIncome();
            break;
         }
         this.listQuery.goodstypes = pubstat;
         this.getIncomeList();
       }
     } 
  },
  methods:{
    Recepage(item){
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      if(this.pubstat == '2' || this.pubstat == '3'){
        this.getIncome();
      }else{
         this.getIncomeList();
      }
     
    },
    getIncomeList(){
      incomeList(this.listQuery).then((res)=>{
      if(res.code == 0){
         this.tableData = res.page.list;
         this.total = res.page.totalCount;
      }
      }).catch((err)=>{})
    },
    //收入与支出
    getIncome(){
      incomeList(this.dataQuery).then((res)=>{   
        if(res.code == 0){
          this.tableData = res.page.list;
          this.total = res.page.totalCount;
        }
      }).catch((err)=>{})
    },
     //修改表头样式
    headClass() {
      return "background:#FF7402;text-align:center;color:white;";
    },
  }   
}
</script>
<style lang="less" scoped>
.err{
  color: #ef9c9a;
}
.gren{
   color: #56c451;
}
.dn{
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/TabPane.vue